@if (showTabs()) {
  <aw-fields-tabs [stepName]="stepName"></aw-fields-tabs>
}
@if (!showTabs()) {
  <aw-fields></aw-fields>
}